// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

import { gql } from '@apollo/client';
import { useQuery } from '@ion/api';

export const GET_ALL_ANALYTICS_FILES = gql`
  query GetAllAnalyticsFiles($where: analytics_files_bool_exp) {
    analyticsFiles: analytics_files(order_by: { pipeline: { name: asc } }, where: $where) {
      id
      updatedAt
      pipelineId
      integrations
      pipeline {
        id
        name
        writekey
        clusterId
        cluster {
          name
          url
        }
      }
      analytics_file_settings {
        id
        host
        cdnURL
        compressFile
        minifyFile
        botFilterEnabled
        matchIDConsentCode
        impliedConsent
        cookieName
        itpSettings
        fileHostingType
        analyticsFileId
        windowVariableName
        storagePrefix
        storageType
        storageDatabase
        consentSource
        optInValues
        globalPrivacyControl
      }
      analytics_file_identity_syncs {
        id
        settings
        consentCategoryId
        tcfEnabled
        identity_sync {
          id
          name
          friendlyName
        }
        consent_category {
          code
        }
      }
      google_tag_settings {
        id
        loadGtag
        loadWhenConsentDenied
        tagId
        egsm
      }
    }
  }
`;

export default function useQueryAllAnalyticsFiles({ fileHostingType, ...options } = {}) {
  const where = fileHostingType ? { analytics_file_settings: { fileHostingType: { _eq: fileHostingType } } } : null;

  const { data, loading, error } = useQuery(GET_ALL_ANALYTICS_FILES, {
    variables: { where },
    ...options,
  });

  const transformedData = data?.analyticsFiles?.map(file => ({
    id: file.id,
    updatedAt: file.updatedAt,
    pipelineId: file.pipelineId,
    pipeline: file.pipeline,
    settings: file.analytics_file_settings,
    identitySyncs: file.analytics_file_identity_syncs,
    integrations: file.integrations,
    googleTagSettings: file.google_tag_settings,
  }));

  return {
    data: transformedData,
    loading,
    error,
  };
}
